export default __webpack_public_path__ + "static/media/026-polo shirt.6d5c4569.svg";